export enum ActionType {
  GET_USERS = 'GET_USERS',
  GET_USERS_REJECTED = 'GET_USERS_REJECTED',
  GET_USERS_FULFILLED = 'GET_USERS_FULFILLED',
  GET_MORE_USERS = 'GET_MORE_USERS',
  GET_MORE_USERS_REJECTED = 'GET_MORE_USERS_REJECTED',
  GET_MORE_USERS_FULFILLED = 'GET_MORE_USERS_FULFILLED',
  DELETE_USER = 'DELETE_USER',
  DELETE_USER_REJECTED = 'DELETE_USER_REJECTED',
  DELETE_USER_FULFILLED = 'DELETE_USER_FULFILLED',
  ADD_USER = 'ADD_USER',
  ADD_USER_REJECTED = 'ADD_USER_REJECTED',
  ADD_USER_FULFILLED = 'ADD_USER_FULFILLED',
  EDIT_USER = 'EDIT_USER',
  EDIT_USER_REJECTED = 'EDIT_USER_REJECTED',
  EDIT_USER_FULFILLED = 'EDIT_USER_FULFILLED',
}
export default ActionType;
